import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { performCqrsQueryFind } from '@dreryk/command-query-react-common';

import { useCallback } from '~libs.ui.react';

import { useSetCurrentPractitionerGlobalState } from './useSetCurrentPractitionerGlobalState';

type RefetchCurrentPractitioner = () => Promise<void>;

export const useRefetchCurrentPractitioner = (): RefetchCurrentPractitioner => {
   const setCurrentPractitioner = useSetCurrentPractitionerGlobalState();

   return useCallback(async () => {
      const currentPractitioner = await performCqrsQueryFind<PractitionerDetails>(() => new CurrentPractitionerQuery());

      if (currentPractitioner) {
         setCurrentPractitioner(currentPractitioner);
      }
   }, [setCurrentPractitioner]);
};
